module.exports = __webpack_public_path__ + "static/img/8@2x.247aa11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home/8@2x.png
// module id = 3GKM
// module chunks = 0